import formMixin from '../../formMixin';
import cloneDeep from 'lodash/cloneDeep';
import inputRules from '@/mixins/input-rules';
import ApiService from '@/services/apiService';
import { get } from 'lodash';
export default {
  name: 'NiotaClassicDevicetypesPacketParserFunction',
  mixins: [formMixin, inputRules],
  props: {
    parserConfig: {
      type: Object,
      required: true
    },
    accountId: {
      type: Number,
      required: true
    },
    switchParserMode: {
      type: Boolean,
      required: false,
      default: false
    },
    customTestFunction: {
      type: Function,
      requirded: false,
      default: null
    },
    callFromDeviceType: {
      type: Boolean,
      required: false,
      default: false
    },
    readonly: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data: function () {
    return {
      parserCodeExpansion: 1,
      parserConfigInternal: cloneDeep(this.parserConfig)
    };
  },
  computed: {
    modeClass() {
      return this.UiTheme ? 'dark' : 'light';
    },
    formElement() {
      return this.$refs.form;
    },
    scriptEditorValue() {
      switch (this.parserConfigInternal.scriptType) {
        case 'javascript':
          return this.parserConfigInternal.custom_function_js;
        case 'elixir':
          return this.parserConfigInternal.custom_function_ex;
        case 'url':
          return this.parserConfigInternal.custom_function_url;
        default:
          return '';
      }
    }
  },
  watch: {
    UiTheme() {
      this.cmOptions.theme = this.UiTheme ? 'base16-dark' : 'duotone-light';
    },
    parserConfig: {
      handler: function (newVal) {
        this.parserConfigInternal = cloneDeep(newVal);
      },
      deep: true
    }
  },
  created() {
    if (this.parserConfigInternal.custom_function_ex) {
      this.parserConfigInternal.scriptType = 'elixir';
    } else if (this.parserConfigInternal.custom_function_url) {
      this.parserConfigInternal.scriptType = 'url';
    } else {
      this.parserConfigInternal.scriptType = 'javascript';
    }
    this.changedScriptType(this.parserConfigInternal.scriptType);
  },
  methods: {
    scriptParamsTransformer(payload, paramsFromForm) {
      const meta = {
        lora: {
          fport: parseInt(paramsFromForm.loraFramePort)
        },
        device_id: -1,
        device_type_id: -1
      };
      return [payload, meta];
    },
    changedScriptType(type) {
      this.parserConfigInternal.scriptType = type;
      if (this.parserConfigInternal.scriptType === 'elixir') {
        delete this.parserConfigInternal.custom_function_js;
        delete this.parserConfigInternal.custom_function_url;
        this.parserConfigInternal.custom_function_ex = this.parserConfigInternal.custom_function_ex || '';
      } else if (this.parserConfigInternal.scriptType === 'url') {
        delete this.parserConfigInternal.custom_function_js;
        delete this.parserConfigInternal.custom_function_ex;
        this.parserConfigInternal.custom_function_url = this.parserConfigInternal.custom_function_url || 'http://';
      } else {
        delete this.parserConfigInternal.custom_function_ex;
        delete this.parserConfigInternal.custom_function_url;
        this.parserConfigInternal.scriptType = 'javascript';
        this.parserConfigInternal.custom_function_js = this.parserConfigInternal.custom_function_js || '';
      }
      this.emitChanges();
    },
    emitChanges() {
      const clonedParserConfig = cloneDeep(this.parserConfigInternal);
      this.$emit('config-updated', clonedParserConfig);
    },
    onCalculationChange(newCalculateElements) {
      this.parserConfigInternal = {
        ...this.parserConfigInternal,
        calculateElements: newCalculateElements
      };
      this.emitChanges();
    },
    onTypeDefinitionsUpdated(newVariables) {
      this.parserConfigInternal = {
        ...this.parserConfigInternal,
        variables: newVariables
      };
      this.emitChanges();
    },
    onScriptChange(newScript) {
      if (this.parserConfigInternal.scriptType === 'elixir') {
        this.parserConfigInternal.custom_function_ex = newScript;
      } else if (this.parserConfigInternal.scriptType === 'url') {
        this.parserConfigInternal.custom_function_url = newScript;
      } else {
        this.parserConfigInternal.custom_function_js = newScript;
      }
      this.parserConfigInternal = cloneDeep(this.parserConfigInternal);
      this.emitChanges();
    },
    async testParserFunction(payload, params) {
      const meta = {
        lora: {
          fport: parseInt(params.loraFramePort)
        },
        device_id: -1
      };
      try {
        if (typeof this.customTestFunction === 'function') {
          meta.device_driver_id = -1;
          return await this.customTestFunction(payload, meta);
        } else {
          meta.device_type_id = -1;
          return await this.testClassicDeviceTypeParser(payload, meta);
        }
      } catch (e) {
        console.error(e);
        return get(e, 'response.data.data', {
          error: e.message
        });
      }
    },
    async testClassicDeviceTypeParser(payload, meta) {
      try {
        // deprecating the parsing via N1-API by using
        // the devicedriver parser functionality. If problems occur check:
        // https://gitlab.com/digimondo-code/niotix/-/merge_requests/4053
        // and https://digimondo.atlassian.net/browse/RD-7499
        const parser = {
          type: 'function',
          config: this.parserConfig
        };
        const payloadWithMeta = {
          payload,
          meta
        };
        return await ApiService.deviceDriverParsePayload(parser, payloadWithMeta);
      } catch (error) {
        console.error('Test-payload parsing failed', get(error, 'response.data.err', error));
        return {
          error
        };
      }
    }
  }
};